// extracted by mini-css-extract-plugin
export default {"container":"Checkbox-module__container--8D4Ja"};